define([], () => {
    return {
        page: 0,
        lat: null,
        lng: null,
        city: null,
        salons: [],
        salePoints: [],
        count: null,
        firstRequest: true,
    };
});
